export default __webpack_public_path__ + "../staticImages/einschenk2-260.png";